import {Component, EventEmitter, HostListener, OnDestroy, OnInit, Output} from '@angular/core';
import {MainLightboxService} from '../main-lightbox.service';
import {filter} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {Image} from '../image';
import {MobileViewService} from 'gelios-ng-admin-components';

@Component({
  selector: 'app-main-lightbox',
  templateUrl: './main-lightbox.component.html',
  styleUrls: ['./main-lightbox.component.scss']
})
export class MainLightboxComponent implements OnInit, OnDestroy {
  selectedImage: Image = null;
  @Output() showChange = new EventEmitter<boolean>();
  @Output() indexImageChange = new EventEmitter<string>();

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
    this.hideLightbox();
  }

  constructor(
    public mainLightboxService: MainLightboxService,
    public mobileView: MobileViewService
  ) {
  }

  ngOnInit() {
    combineLatest(
      this.mainLightboxService.images,
      this.mainLightboxService.selectedImageIndex,
    ).pipe(filter(([images, index]) => images !== null && index !== null))
      .subscribe(([images, index]) => {
        this.selectedImage = images[index];
      });
  }

  hideLightbox() {
    this.mainLightboxService.show.next(false);
  }

  ngOnDestroy() {
    this.mainLightboxService.arrowClicked.next(null);
  }
}
